import React from 'react';
import PropTypes from 'prop-types';
import { useLocation, useHistory } from 'react-router-dom';
import { filter } from 'ramda';
import { appRoutes } from 'routes';
import useScreen from 'hooks/useScreen';
import useFirebaseChat from 'reducers/hooks/firebase/useChat';
import useApp from 'reducers/hooks/useApp';

import ChatsPresenter from 'presenters/ChatsPresenter';
import UserPresenter from 'presenters/UserPresenter';
import DesktopMenu from './components/DesktopMenu';
import MobileMenu from './components/MobileMenu';

const DEVICE_TYPES = {
  mobile: 'mobile',
  desktop: 'desktop',
};

const BUYER_MENU_ITEMS = [
  {
    name: 'mortgageInfo',
    label: 'layouts.AppLayout.Menu.mortgageInfo',
    path: appRoutes.surveyPath(),
    iconName: 'home',
    desktop: false,
    mobile: true,
  },
  {
    name: 'messages',
    label: 'layouts.AppLayout.Menu.messages',
    path: appRoutes.messagesPath(),
    iconName: 'mail',
    desktop: true,
    mobile: true,
  },
  {
    name: 'calculators',
    label: 'layouts.AppLayout.Menu.calculators',
    path: appRoutes.calculatorsPath(),
    iconName: 'questionMark',
    desktop: true,
    mobile: true,
  },
];

const LOAN_OFFICER_MENU_ITEMS = [
  {
    name: 'dashboard',
    label: 'layouts.AppLayout.Menu.dashboard',
    path: appRoutes.dashboardPath(),
    iconName: 'home',
    desktop: true,
    mobile: true,
  },
  {
    name: 'messages',
    label: 'layouts.AppLayout.Menu.connections',
    path: appRoutes.messagesPath(),
    iconName: 'mail',
    desktop: true,
    mobile: true,
  },
  {
    name: 'rea',
    label: 'layouts.AppLayout.Menu.findRealEstateAgents',
    path: appRoutes.loanOfficerFindRealEstateAgents(),
    iconName: 'agents',
    desktop: true,
    mobile: true,
  },
];

const ADMIN_MENU_ITEMS = [
  {
    name: 'dashboard',
    label: 'layouts.AppLayout.Menu.dashboard',
    path: appRoutes.dashboardPath(),
    iconName: 'home',
    desktop: true,
    mobile: true,
  },
];

const REAL_ESTATE_AGENT_MENU_ITEMS = [
  {
    name: 'dashboard',
    label: 'layouts.AppLayout.Menu.dashboard',
    path: appRoutes.rootPath(),
    iconName: 'home',
    desktop: true,
    mobile: true,
  },
];

const Menu = props => {
  const { isDesktop } = useScreen();

  const { chats, resetFirebase } = useFirebaseChat();
  const { currentUser, isOnline } = props;
  const { logout } = useApp();
  const { pathname } = useLocation();
  const history = useHistory();

  const isCurrentLocation = currentPath => pathname === currentPath;
  const hadleLogout = () => {
    logout();
    resetFirebase(currentUser.id, chats);
    history.push(appRoutes.rootPath());
  };

  const unreadCount = ChatsPresenter.unreadCount(chats);

  const menuItemsMapper = {
    buyer: BUYER_MENU_ITEMS,
    loanOfficer: LOAN_OFFICER_MENU_ITEMS,
    administrator: ADMIN_MENU_ITEMS,
    realEstateAgent: REAL_ESTATE_AGENT_MENU_ITEMS,
  };

  const type = isDesktop ? DEVICE_TYPES.desktop : DEVICE_TYPES.mobile;
  const menuItems = menuItemsMapper[UserPresenter.formatUserType(currentUser)];
  const menuItemsFilteredByDeviceType = filter(item => item[type], menuItems).map(item => ({
    ...item,
    isActive: isCurrentLocation(item.path),
  }));

  return isDesktop ? (
    <DesktopMenu
      currentUser={currentUser}
      isOnline={isOnline}
      menuItems={menuItemsFilteredByDeviceType}
      unreadCount={unreadCount}
      logout={hadleLogout}
    />
  ) : (
    <MobileMenu
      menuItems={menuItemsFilteredByDeviceType}
      currentUser={currentUser}
      logout={hadleLogout}
      unreadCount={unreadCount}
    />
  );
};

Menu.propTypes = {
  currentUser: UserPresenter.shape().isRequired,
  isOnline: PropTypes.bool.isRequired,
};

export default Menu;



// WEBPACK FOOTER //
// ./src/layouts/AppLayout/components/Menu/Menu.js